import styled from 'styled-components';
import getThemeTypography, { Typographies } from '../../utils/getThemeTypography';
export var subTitleTypography = styled.p(getThemeTypography(Typographies.SUBTITLE));
